// React Imports
import React, { useEffect, useState } from "react";

// Project Imports
import { Form } from "react-bootstrap";
import { observer } from "mobx-react";

// Package Imports
import { BottomsheetDropdown, CustomCheckbox, DatepickerModal } from "components";
import { CalenderIcon, DOBIcon, GenderIcon, IncomeIcon, MonthlyIncomeIcon, NationalityIcon, lifeCoverIcon } from "constants/Images";
import checkIsValueEmpty from "utils/checkIsValueEmpty";
import FamilyMemberTypeEnum from "../FamilymemberTypeEnum";

import { ACCEPT_NATIONALITY, NUMBER_REGEX } from 'constants/Constants'
import { LA_PR_FAMILY_PROFILE } from "../../../constants/UserClicksConstant";

// CSS Imports
import "./add-family-member-card.css";
import { object } from "prop-types";
import moment from "moment";
import AuthStore from "modules/login/store/AuthStore";
import { toJS } from "mobx";
import { getEligibleProposerList, updateMemberType } from "modules/family-details-form/form/utils";
import FamilyDetailsStore from "../store/FamilyDetailsStore";
import { MWP_ACT } from "constants/ CustomerType";
import isObjectEmpty from "utils/isObjectEmpty";


const AddFamilyMemberData = ({ member, updateValues, onAddNameClick, memberCount, formController, setLastSelectedLa, setLastSelectedPR, isProtectionNeedSelected, lastSelectedLA, key, setSecondaryLA, isNotProtectionNeedSelected, setsecondaryLAValue }) => {
    let journeyData = toJS(AuthStore.journeyData)
    console.log("journeyData ", journeyData?.family_product_details_list)
    let familyData = Object.entries(formController.$("members").get())
    const listOfSelectedFamilyMembers = familyData.filter((item) => item[1].extra.isSelected)
    let otherMemberSelected = false
    console.log("isNotProtectionNeedSelected ", isNotProtectionNeedSelected)
    useEffect(() => {

        familyData.forEach((member) => {
            if (member[1].fields["life_assured"].value) {
                otherMemberSelected = true
            }
        })

        if (journeyData && familyData) {
            if (!isProtectionNeedSelected && AuthStore.journeyTypeName != MWP_ACT) {

                if (memberCount === listOfSelectedFamilyMembers.length && memberCount === journeyData?.family_details_list.length) {
                    familyData.forEach((data, index) => {



                        if (journeyData?.family_details_list.length >= 2 && index == 1 && !otherMemberSelected) {
                            if (journeyData?.family_details_list[1]?.family_member_type.toLowerCase() === data[0]) {

                                updateValues(formController, "self", "life_assured", false)
                                updateValues(formController, data[0], "life_assured", true)
                                updateValues(formController, "self", "proposer", true)
                                updateValues(formController, data[0], "proposer", false)
                                onChangeLifeAssured(true, data)
                            }
                        }
                        if (journeyData?.family_details_list.length >= 2 && index == 1 && !FamilyDetailsStore.isMemberDetailsFillUp) {
                            if (journeyData?.family_details_list[1]?.family_member_type.toLowerCase() === data[0]) {

                                updateValues(formController, "self", "life_assured", false)
                                updateValues(formController, data[0], "life_assured", true)
                                updateValues(formController, "self", "proposer", true)
                                updateValues(formController, data[0], "proposer", false)
                                onChangeLifeAssured(true, data)

                            }
                        }
                    })
                }
                if (memberCount >= 2 && memberCount === listOfSelectedFamilyMembers.length && listOfSelectedFamilyMembers.length >= 2 && memberCount === journeyData?.family_details_list.length && !otherMemberSelected) {
                    let dob = checkMemberIsMinor(listOfSelectedFamilyMembers[1][1].value.dob)
                    if (dob) {
                        updateValues(formController, "self", "life_assured", false)
                        updateValues(formController, listOfSelectedFamilyMembers[1][0], "life_assured", true)
                        updateValues(formController, "self", "proposer", true)
                        updateValues(formController, listOfSelectedFamilyMembers[1][0], "proposer", false)
                        onChangeLifeAssured(true, listOfSelectedFamilyMembers[1])
                        // listOfSelectedFamilyMembers.forEach((item) => {
                        //     formController.$("members").$(item[0]).$('secondary_la').set("disabled", true)
                        // })

                    } else {
                        updateValues(formController, "self", "life_assured", false)
                        updateValues(formController, listOfSelectedFamilyMembers[1][0], "life_assured", true)
                        updateValues(formController, "self", "proposer", true)
                        updateValues(formController, listOfSelectedFamilyMembers[1][0], "proposer", false)
                        onChangeLifeAssured(true, listOfSelectedFamilyMembers[1])
                    }

                }
            } else {
                if (memberCount >= 2 && memberCount === listOfSelectedFamilyMembers.length) {

                    familyData.forEach((data, index) => {

                        if (index == 1 && !otherMemberSelected) {
                            updateValues(formController, "self", "life_assured", false)
                            updateValues(formController, data[0], "life_assured", true)
                            updateValues(formController, "self", "proposer", false)
                            updateValues(formController, data[0], "proposer", true)
                            onChangeLifeAssured(true, data)
                        }
                    })
                }
            }
            if (memberCount === journeyData?.family_details_list.length && memberCount === 1) {
                updateValues(formController, "self", "life_assured", true)
                updateValues(formController, "self", "proposer", true)
            }
        }
    }, [memberCount])

    let memberfieldData = member[1].fields

    console.log("nnnn>> ", memberfieldData)
    let isFirstNameEntered = checkIsValueEmpty(memberfieldData.first_name.value)
    let isLastNameEntered = checkIsValueEmpty(memberfieldData.middle_name.value)
    let isMiddleNameEntered = checkIsValueEmpty(memberfieldData.last_name.value)
    let isNameEntered = false
    let name = ""

    if (!isFirstNameEntered || !isLastNameEntered || !isMiddleNameEntered) {
        isNameEntered = true
        name = memberCount + "." + " " + memberfieldData.salutation.value.label + " " + memberfieldData.first_name.value + " " + memberfieldData.middle_name.value + " " + memberfieldData.last_name.value
    }

    let memberAge = moment().diff(moment(memberfieldData.dob.value), 'years')
    // console.log('memberfieldData.dob.value ', member[0], memberAge)
    // if (isProtectionNeedSelected) {
    //     if (memberAge >= 85) {
    //         updateValues(formController, member[0], 'life_assured', false)
    //         age(true)
    //     } else if (memberfieldData.proposer.value === true) {
    //         updateValues(formController, member[0], 'life_assured', true)
    //         age(false)
    //     } 
    // } else {
    //     if (memberAge >= 85) {
    //         updateValues(formController, member[0], 'life_assured', false)
    //         age(true)
    //     }else{
    //         age(false)
    //     }

    // }

    const checkMemberIsMinor = (journeyData) => {
        let D0B = journeyData
        const today = moment();
        const birthdateMoment = moment(D0B);
        const age = today.diff(birthdateMoment, 'years');
        if (age <= 45) {
            return true
        } else {
            return false
        }


    }


    const showmonthlyIncome = memberfieldData.monthly_income_value.extra.visible

    const memmberNameFormatFunction = (memberName) => {
        let member = FamilyMemberTypeEnum.GRAND_MOTHER === memberName.toUpperCase() ? "Mother" : FamilyMemberTypeEnum.GRAND_FATHER === memberName.toUpperCase() ? "Father" : memberName
        return member.charAt(0).toUpperCase() + member.slice(1).split('_').join(' ')
    }

    const onChangeLifeAssured = (value, selectedMember) => {
        updateValues(formController, selectedMember ? selectedMember[0] : member[0], 'life_assured', value)
        if (isProtectionNeedSelected) {
            updateValues(formController, selectedMember ? selectedMember[0] : member[0], "proposer", value)
            setLastSelectedPR(selectedMember ? selectedMember[0] : member[0])
        }
        setLastSelectedLa(selectedMember ? selectedMember[0] : member[0])
        if (value) getEligibleProposerList(selectedMember ? selectedMember : member, formController, journeyData)
    }

    const onChangeProposer = (value) => {
        setLastSelectedPR(member[0])
        if (isProtectionNeedSelected) {
            updateValues(formController, member[0], "proposer", value)
            updateValues(formController, member[0], "life_assured", value)
            setLastSelectedLa(member[0])
        } else {
            familyData.forEach((data) => {
                if (member[0] === data[0] && value) {
                    updateValues(formController, data[0], "proposer", value)
                } else {
                    updateValues(formController, data[0], "proposer", false)
                }
            })
        }
    }

    const onSecondaryLAChanges = (value) => {

        setSecondaryLA(member[0])
        setsecondaryLAValue(value)
    }

    useEffect(() => {
        if (member[0] === lastSelectedLA) {
            getEligibleProposerList(member, formController, journeyData)
        }
    }, [lastSelectedLA])

    function calculateAge(birthdate, isLA, memberData) {
        let memberType = memberData?.family_member_type?.value
        let currentLaMemberType = familyData?.reduce((type, member) => {
            return member[1]?.fields["life_assured"]?.value ? member[1]?.fields["family_member_type"]?.value : type;
        }, 0);

        console.log("calculateAge ", memberType, currentLaMemberType)
        if (memberType === FamilyMemberTypeEnum.GRAND_CHILD && (currentLaMemberType === FamilyMemberTypeEnum.GRAND_FATHER || currentLaMemberType === FamilyMemberTypeEnum.GRAND_MOTHER)) {
            return false
        }
        const today = moment();
        const parseDate = (date) =>
            moment(date, moment.ISO_8601, true).isValid() ? moment(date) : moment(date, "DD-MM-YYYY", true);

        let currentLaMemberAge = familyData?.reduce((age, member) => {
            const dobValue = member[1]?.fields["dob"]?.value;
            return member[1]?.fields["life_assured"]?.value && dobValue ? today.diff(parseDate(dobValue), 'years') : age;
        }, 0);

        const age = today.diff(parseDate(birthdate), 'years');
        console.log("currentLaMemberAge ", age, currentLaMemberAge);

        return age <= 45 && (currentLaMemberAge <= 50 && currentLaMemberAge!== 0) && !isLA;
    }


    const showMembertypeListDropdown = () => {
        let familyDetailsList = toJS(AuthStore.journeyData.family_details_list)
        let checkMemberTypeEmpty = familyDetailsList.some(item => item?.family_member_type === null)
        return checkMemberTypeEmpty
    }

    return (
        <div className='px-3 px-xl-2 border-bottom mt-3 pb-3'>
            <div className='d-flex justify-content-between'>
                {member[0] !== "other" && isObjectEmpty(memberfieldData?.member_type_list.value) &&
                    <p className='mt-1 mb-0 mr-1 font-size-lg-12 font-size-14 font-weight-medium font-weight-lg-light text-secondary'>
                        {`${memberCount}. ${memmberNameFormatFunction(member[0])}`}
                    </p>

                }


                {member[0] !== "self" && showMembertypeListDropdown() &&
                    <div className='mt-3 mt-xl-0  pr-xl-2 d-none d-lg-block' >
                        <div className='d-flex d-xl-none align-items-center'>
                            <p className='font-size-14 font-size-md-12 font-weight-normal text-description-text-color  mb-0'>
                                {memberfieldData.member_type_list.label}
                            </p>
                        </div>
                        <div className='d-flex'>
                            <BottomsheetDropdown
                                dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
                                menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
                                menuItemStyle='d-flex justify-content-between align-items-center'
                                selectedLabelKey='label'
                                bottomsheetTitle={memberfieldData.member_type_list.extra.bottomSheetTitle}
                                defaultLabel={memberfieldData.member_type_list.label}
                                menuList={memberfieldData.member_type_list.extra.optionList}
                                value={memberfieldData.member_type_list.value}
                                onSelect={(value) => {
                                    formController.$("members").$(member[0]).$('member_type_list').set("value", value),
                                        updateMemberType(formController, value)
                                }}
                                showErrorMsg={memberfieldData.member_type_list.error != null}
                                errorMsg={memberfieldData.member_type_list.error}
                                disabled={false}
                            />
                        </div>
                    </div>
                }
                {/* nationality in mobile view */}
                <div className="d-flex flex-column  d-lg-none">
                    <div className='d-flex align-items-center justify-content-between d-lg-none mb-2'>
                        <div className='d-flex d-xl-none align-items-center  mb-1'>
                            <p className='font-size-14 font-size-md-12 font-weight-normal text-description-text-color ml-1 mb-0 ml-md-3 pr-1'>
                                {memberfieldData.nationality.label}
                            </p>
                        </div>

                        <div className='d-flex'>
                            <BottomsheetDropdown
                                dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
                                menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
                                menuItemStyle='d-flex justify-content-between align-items-center'
                                selectedLabelKey='label'
                                bottomsheetTitle={memberfieldData.nationality.extra.bottomSheetTitle}
                                defaultLabel={memberfieldData.nationality.label}
                                menuList={memberfieldData.nationality.extra.optionList}
                                value={memberfieldData.nationality.value}
                                onSelect={(value) => updateValues(formController, member[0], 'nationality', value)}
                                showErrorMsg={memberfieldData.nationality.error != null}
                                disabled={false}
                            />
                        </div>
                    </div>
                    {ACCEPT_NATIONALITY.includes(memberfieldData.nationality.value.label) &&
                        <div className='d-flex align-items-center justify-content-between d-lg-none'>
                            <div className='d-flex d-xl-none align-items-center  mb-1'>
                                <p className='font-size-14 font-size-md-12 font-weight-normal text-description-text-color ml-1 mb-0 ml-md-3 pr-1'>
                                    {memberfieldData.payment_option.label}
                                </p>
                            </div>

                            <div className='d-flex'>
                                <BottomsheetDropdown
                                    dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
                                    menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
                                    menuItemStyle='d-flex justify-content-between align-items-center'
                                    selectedLabelKey='label'
                                    bottomsheetTitle={memberfieldData.payment_option.extra.bottomSheetTitle}
                                    defaultLabel={memberfieldData.payment_option.label}
                                    menuList={memberfieldData.payment_option.extra.optionList}
                                    value={memberfieldData.payment_option.value}
                                    onSelect={(value) => updateValues(formController, member[0], 'payment_option', value)}
                                    showErrorMsg={memberfieldData.payment_option.error != null}
                                    errorMsg={memberfieldData.payment_option.error}
                                    disabled={false}
                                />
                            </div>
                        </div>
                    }
                </div>
                <div className="d-none d-lg-block">
                    {(calculateAge(memberfieldData?.dob?.value, memberfieldData.life_assured.value, memberfieldData) && isNotProtectionNeedSelected) &&

                        <CustomCheckbox
                            shape='rounded'
                            title={memberfieldData.secondary_la.label}
                            containerStyle='col-0 text-nowrap mb-0 pl-0 pr-1 align-items-center'
                            titleStyle='fw-medium font-size-14 pl-1 pr-2  details-title-text'
                            isChecked={memberfieldData.secondary_la.value}
                            // onChange={(value)=> {updateValues(formController,member[0],'secondary_la', value)}}
                            onChange={(value) => onSecondaryLAChanges(value)}
                            mark='checkmark'
                            disabled={memberfieldData.secondary_la.disabled}
                        />
                    }
                    <CustomCheckbox
                        shape='rounded'
                        title={memberfieldData.life_assured.label}
                        containerStyle='col-0 text-nowrap mb-0 pl-0 pr-1 align-items-center'
                        titleStyle='fw-medium font-size-14 pl-1 pr-2  details-title-text'
                        isChecked={memberfieldData.life_assured.value}
                        onChange={(value) => {
                            onChangeLifeAssured(value),
                                //!for save user clicks
                                AuthStore.saveUserClicks(LA_PR_FAMILY_PROFILE)
                        }}
                        mark='checkmark'
                        disabled={memberfieldData.life_assured.disabled || memberAge >= 85 ? true : false}
                    />

                    <CustomCheckbox
                        shape='rounded'
                        title={memberfieldData.proposer.label}
                        containerStyle='col-0 text-nowrap mb-0 pl-0 pr-1 align-items-center'
                        titleStyle='fw-medium font-size-14 pl-1 pr-2 details-title-text '
                        isChecked={memberfieldData.proposer.value}
                        onChange={(value) => {
                            onChangeProposer(value),
                                //!for save user clicks
                                AuthStore.saveUserClicks(LA_PR_FAMILY_PROFILE)
                        }}
                        mark='checkmark'
                        disabled={memberfieldData.proposer.disabled}
                    />
                </div>
            </div>

            <hr className='w-100 border-secondary-opacity-50 my-2 d-lg-none' />

            <div className="d-block d-lg-none d-flex align-items-center justify-content-between mb-2">
                {(calculateAge(memberfieldData?.dob?.value, memberfieldData.life_assured.value, memberfieldData) && isNotProtectionNeedSelected) &&

                    <CustomCheckbox
                        shape='rounded'
                        title={memberfieldData.secondary_la.label}
                        containerStyle='col-0 text-nowrap mb-0 pl-0 pr-1 align-items-center'
                        titleStyle='fw-medium font-size-14 pl-1 pr-2  details-title-text'
                        isChecked={memberfieldData.secondary_la.value}
                        // onChange={(value)=> {updateValues(formController,member[0],'secondary_la', value)}}
                        onChange={(value) => onSecondaryLAChanges(value)}
                        mark='checkmark'
                        disabled={memberfieldData.secondary_la.disabled}
                    />
                }

                <CustomCheckbox
                    shape='rounded'
                    title={memberfieldData.life_assured.label}
                    containerStyle='col-0 text-nowrap mb-0 pl-0 pr-1 align-items-center'
                    titleStyle='fw-medium font-size-14 pl-1 pr-2  details-title-text'
                    isChecked={memberfieldData.life_assured.value}
                    onChange={(value) => {
                        onChangeLifeAssured(value),
                            //!for save user clicks
                            AuthStore.saveUserClicks(LA_PR_FAMILY_PROFILE)
                    }}
                    mark='checkmark'
                    disabled={memberfieldData.life_assured.disabled || memberAge >= 85 ? true : false}
                />

                <CustomCheckbox
                    shape='rounded'
                    title={memberfieldData.proposer.label}
                    containerStyle='col-0 text-nowrap mb-0 pl-0 pr-1 align-items-center'
                    titleStyle='fw-medium font-size-14 pl-1 pr-2 details-title-text '
                    isChecked={memberfieldData.proposer.value}
                    onChange={(value) => {
                        onChangeProposer(value),
                            //!for save user clicks
                            AuthStore.saveUserClicks(LA_PR_FAMILY_PROFILE)
                    }}
                    mark='checkmark'
                    disabled={memberfieldData.proposer.disabled}
                />
            </div>
            <div className='mt-1 d-flex flex-wrap'>
                <div className='family-member-name-section d-flex flex-lg-row justify-content-between'>
                    {/* <p
                        className='mt-1 mb-0 font-size-lg-12 font-size-14 font-weight-medium font-weight-lg-light text-secondary'
                    >
                        {
                            isNameEntered
                                ? name
                                : [member[1].label]
                        }
                        {
                            isNameEntered
                                ? null
                                : <span onClick={onAddNameClick}
                                    className="font-size-14 font-size-lg-12 font-weight-light text-description-text-color pl-1 cursor-pointer"
                                >
                                    {'TAP TO ADD NAME'}
                                </span>
                        }

                    </p> */}

                    <div className="mr-lg-2 mb-0 mb-lg-0 pr-2 pr-md-0">
                        <div className="d-flex align-middle">

                            {/* <p className='mt-1 mb-0 mr-1 font-size-lg-12 font-size-14 font-weight-medium font-weight-lg-light text-secondary'>
                                        {memberCount}
                                        </p> */}
                            <div className="w-100">
                                <BottomsheetDropdown
                                    tabindex={key + '1' + 8}
                                    dropdownStyle='font-size-lg-12 font-size-14 font-weight-light salutation-dropdown'
                                    menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
                                    menuItemStyle='d-flex justify-content-between align-items-center'
                                    selectedLabelKey='label'
                                    bottomsheetTitle={memberfieldData.salutation.extra.bottomSheetTitle}
                                    defaultLabel=''
                                    menuList={memberfieldData.salutation.extra.optionList}
                                    onSelect={(value) => updateValues(formController, member[0], "salutation", value)}
                                    value={memberfieldData.salutation.value}
                                    showErrorMsg={memberfieldData.salutation.error !== null}
                                    errorMsg={memberfieldData.salutation.error}
                                    disabled={memberfieldData.salutation.disabled}
                                />
                            </div>
                        </div>
                    </div>


                    <div className="mb-0 mb-lg-0 pr-2 pr-md-0">
                        <Form.Control
                            tabindex={key + 8 + '2'}
                            placeholder={memberfieldData.first_name.placeholder}
                            value={memberfieldData.first_name.value}
                            onChange={(event) => updateValues(formController, member[0], "first_name", event.target.value)}
                            disabled={memberfieldData.first_name.disabled}
                            className={`${memberfieldData.first_name.error !== null ? "validation-border font-weight-light font-size-12" : "font-size-12 font-weight-light "} calculator-monthly-income-field`}
                            style={{ border: "1px solid #797979" }}
                        />
                        {memberfieldData.first_name.error && (
                            <p className='text-danger mb-0 font-weight-light font-size-12 align-items-start d-flex'>
                                {memberfieldData.first_name.error}
                            </p>
                        )}
                    </div>

                    <div className="mx-lg-2 mb-0 mb-lg-0 pr-2 pr-md-0">
                        <Form.Control
                            tabindex={key + 8 + '3'}
                            placeholder={memberfieldData.middle_name.placeholder}
                            value={memberfieldData.middle_name.value}
                            onChange={(event) => updateValues(formController, member[0], "middle_name", event.target.value)}
                            disabled={memberfieldData.middle_name.disabled}
                            className={`${memberfieldData.middle_name.error !== null ? "validation-border font-weight-light font-size-12" : "font-size-12 font-weight-light "} calculator-monthly-income-field`}
                            style={{ border: "1px solid #797979" }}
                        />
                        {memberfieldData.middle_name.error && (
                            <p className='text-danger mb-0 font-weight-light font-size-12 align-items-start d-flex'>
                                {memberfieldData.middle_name.error}
                            </p>
                        )}
                    </div>

                    <div className="mr-lg-2 mb-0 mb-lg-0 pr-2 pr-md-0">
                        <Form.Control
                            tabindex={key + 8 + '4'}
                            placeholder={memberfieldData.last_name.placeholder}
                            value={memberfieldData.last_name.value}
                            onChange={(event) => updateValues(formController, member[0], "last_name", event.target.value)}
                            disabled={memberfieldData.last_name.disabled}
                            className={`${memberfieldData.last_name.error !== null ? "validation-border font-weight-light font-size-12" : "font-size-12 font-weight-light "} calculator-monthly-income-field`}
                            style={{ border: "1px solid #797979" }}
                        />
                        {memberfieldData.last_name.error && (
                            <p className='text-danger mb-0 font-weight-light font-size-12 align-items-start d-flex'>
                                {memberfieldData.last_name.error}
                            </p>
                        )}
                    </div>


                    {/* gender in table and desktop view */}
                    <div className='other-details-section-gender flex-xs-column flex-lg-row  d-none d-lg-flex'>
                        <img src={GenderIcon} alt='calender-icon' className='add-family-member-card-top-img d-inline d-xl-none mr-1 mb-sm-1 mb-lg-0' />

                        <BottomsheetDropdown
                            tabindex={key + 8 + '5'}
                            dropdownStyle='font-size-lg-12 font-size-14 font-weight-light gender-dropdown'
                            menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
                            menuItemStyle='d-flex justify-content-between align-items-center'
                            selectedLabelKey='label'
                            bottomsheetTitle={memberfieldData.gender.extra.bottomSheetTitle}
                            defaultLabel='Select'
                            disabled={memberfieldData.gender.disabled}
                            menuList={memberfieldData.gender.extra.optionList}
                            onSelect={(value) => updateValues(formController, member[0], 'gender', value)}
                            value={memberfieldData.gender.value}
                            showErrorMsg={memberfieldData.gender.error !== null}
                            errorMsg={memberfieldData.gender.error}
                        />
                    </div>
                </div>
                {/* <hr className='w-100 border-secondary-opacity-50 my-2 d-xl-none d-none d-lg-inline' /> */}

                <div className='family-member-other-details-section justify-content-between '>
                    {/* gender in mobile veiw */}
                    <div className='other-details-section-gender mt-3 mt-xl-0 pr-xl-2 d-lg-none '>
                        <div className='d-flex d-xl-none align-items-center  mb-1'>
                            <img src={GenderIcon} alt='calender-icon' className='add-family-member-card-top-img' />
                            <p className='font-size-14 font-size-md-12 font-weight-light text-description-text-color ml-1 mb-0 ml-md-3'>
                                {memberfieldData.gender.label}
                            </p>
                        </div>

                        <BottomsheetDropdown
                            dropdownStyle='font-size-lg-12 font-size-14 font-weight-light gender-dropdown'
                            menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
                            menuItemStyle='d-flex justify-content-between align-items-center'
                            selectedLabelKey='label'
                            bottomsheetTitle={memberfieldData.gender.extra.bottomSheetTitle}
                            defaultLabel='Select'
                            disabled={memberfieldData.gender.disabled}
                            menuList={memberfieldData.gender.extra.optionList}
                            onSelect={(value) => updateValues(formController, member[0], 'gender', value)}
                            value={memberfieldData.gender.value}
                            showErrorMsg={memberfieldData.gender.error !== null}
                            errorMsg={memberfieldData.gender.error}
                        />
                    </div>

                    <div
                        className={
                            `${memberfieldData.gender.error !== null
                                ? "mt-3 mt-xl-0 other-details-section-dob pr-xl-2"
                                : "mt-3 mt-xl-0 other-details-section-dob pr-xl-2"
                            }`}
                    >
                        <div className='d-flex align-items-center d-xl-none mb-1 mb-lg-2'>
                            <img src={DOBIcon} alt='calender-icon' className='add-family-member-card-top-img' />
                            <p className='font-size-14 font-size-md-12 font-weight-light text-description-text-color ml-1 mb-0 ml-md-3'>
                                {memberfieldData.dob.label}
                            </p>
                        </div>
                        <DatepickerModal
                            tabindex={key + 8 + '6'}
                            minDate={memberfieldData.dob.extra.minDate}
                            maxDate={memberfieldData.dob.extra.maxDate}
                            value={memberfieldData.dob.value}
                            date={memberfieldData.dob.value}
                            onChange={(value) => {
                                updateValues(formController, member[0], 'dob', value),
                                    formController?.$("members")?.$(member[0])?.$('dob').validate()
                            }}
                            showErrorMsg={memberfieldData.dob.error !== null}
                            textStyle='font-size-lg-12 font-size-14 font-weight-light'
                            errorMsg={memberfieldData.dob.error}
                            memberType={member[1].value.family_member_type}
                            disabled={memberfieldData.dob.disabled}
                        />
                    </div>

                    {/* nationality in table & desktop view */}
                    <div className='mt-3 mt-xl-0 other-details-section-nationality pr-xl-2 d-none d-lg-block' >
                        <div className='d-flex d-xl-none align-items-center  mb-1'>
                            <img src={NationalityIcon} alt='income-icon' className='add-family-member-card-top-img' />
                            <p className='font-size-14 font-size-md-12 font-weight-normal text-description-text-color ml-1 mb-0 ml-md-3'>
                                {memberfieldData.nationality.label}
                            </p>
                        </div>

                        <BottomsheetDropdown
                            tabindex={key + 8 + '7'}
                            dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
                            menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
                            menuItemStyle='d-flex justify-content-between align-items-center'
                            selectedLabelKey='label'
                            bottomsheetTitle={memberfieldData.nationality.extra.bottomSheetTitle}
                            defaultLabel={memberfieldData.nationality.label}
                            menuList={memberfieldData.nationality.extra.optionList}
                            value={memberfieldData.nationality.value}
                            onSelect={(value) => updateValues(formController, member[0], 'nationality', value)}
                            showErrorMsg={memberfieldData.nationality.error != null}
                            disabled={false}
                        />
                        {ACCEPT_NATIONALITY.includes(memberfieldData.nationality.value.label) &&
                            <>
                                <div className='d-flex d-xl-none align-items-center  mb-1 mt-2'>
                                    <img src={NationalityIcon} alt='income-icon' className='add-family-member-card-top-img' />
                                    <p className='font-size-14 font-size-md-12 font-weight-normal text-description-text-color ml-1 mb-0 ml-md-3'>
                                        {memberfieldData.payment_option.label}
                                    </p>
                                </div>

                                <BottomsheetDropdown
                                    tabindex={key + 8 + '7'}
                                    dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
                                    menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
                                    menuItemStyle='d-flex justify-content-between align-items-center'
                                    selectedLabelKey='label'
                                    bottomsheetTitle={memberfieldData.payment_option.extra.bottomSheetTitle}
                                    defaultLabel={memberfieldData.payment_option.label}
                                    menuList={memberfieldData.payment_option.extra.optionList}
                                    value={memberfieldData.payment_option.value}
                                    onSelect={(value) => updateValues(formController, member[0], 'payment_option', value)}
                                    showErrorMsg={memberfieldData.payment_option.error != null}
                                    errorMsg={memberfieldData.payment_option.error}
                                    isabled={false}
                                />
                            </>
                        }
                    </div>



                    <div className={`mt-3 mt-xl-0 other-details-section-monthlyincome pr-xl-2
                     ${showmonthlyIncome
                            ? "visible"
                            : "invisible"
                        }
                    `}>
                        <div className='d-flex d-xl-none align-items-center mb-1'>
                            <img src={MonthlyIncomeIcon} alt='income-icon' className='add-family-member-card-top-img' />
                            <p className='font-size-14 font-size-md-12 font-weight-normal text-description-text-color ml-1 mb-0 ml-md-3'>
                                {memberfieldData.monthly_income_value.label}
                            </p>
                        </div>
                        {
                            memberfieldData.monthly_income_value.type === 'text'
                                ? <>
                                    <Form.Control
                                        placeholder={memberfieldData.monthly_income_value.placeholder}
                                        value={memberfieldData.monthly_income_value.value}
                                        onChange={(event) => {

                                            if (NUMBER_REGEX.test(event.target.value)) {
                                                return updateValues(formController, member[0], 'monthly_income_value', event.target.value)
                                            }
                                            if (event.target.value.length <= 1) {
                                                return updateValues(formController, member[0], 'monthly_income_value', '')
                                            }
                                        }}
                                        disabled={memberfieldData.monthly_income_value.disabled}
                                        className={
                                            `${memberfieldData.monthly_income_value.error !== null
                                                ? "validation-border font-weight-light font-size-12"
                                                : "font-size-12 font-weight-light "
                                            } calculator-monthly-income-field`}
                                        style={{ border: "1px solid #797979" }}
                                    />
                                    {memberfieldData.monthly_income_value.error && (
                                        <p className='text-danger mb-0 font-weight-light font-size-12 align-items-start d-flex'>
                                            {memberfieldData.monthly_income_value.error}
                                        </p>
                                    )}
                                </>
                                : <BottomsheetDropdown
                                    tabindex={key + 8 + '8'}
                                    dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
                                    menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
                                    menuItemStyle='d-flex justify-content-between align-items-center'
                                    selectedLabelKey='label'
                                    bottomsheetTitle={memberfieldData.monthly_income_dropdown_option.extra.bottomSheetTitle}
                                    defaultLabel="Select"
                                    menuList={memberfieldData.monthly_income_dropdown_option.extra.optionList}
                                    value={memberfieldData.monthly_income_dropdown_option.value}
                                    onSelect={(value) => updateValues(formController, member[0], 'monthly_income_dropdown_option', value)}
                                    showErrorMsg={memberfieldData.monthly_income_dropdown_option.error != null}
                                    errorMsg={memberfieldData.monthly_income_dropdown_option.error}
                                    disabled={memberfieldData.monthly_income_dropdown_option.disabled}
                                />
                        }
                        <div>

                        </div>
                    </div>
                    <div className='mt-3 mt-xl-0 other-details-section-current-life-cover'>
                        <div className='d-flex d-xl-none align-items-center mb-1'>
                            <img src={lifeCoverIcon} alt='income-icon' className='add-family-member-card-top-img' />
                            <p className='font-size-14 font-size-md-12 font-weight-light text-description-text-color ml-1 mb-0 ml-md-3'>
                                {memberfieldData.current_life_cover.label}
                            </p>
                        </div>
                        <BottomsheetDropdown
                            tabindex={key + 8 + '9'}
                            dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
                            menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
                            menuItemStyle='d-flex justify-content-between align-items-center'
                            selectedLabelKey='label'
                            bottomsheetTitle={memberfieldData.current_life_cover.extra.bottomSheetTitle}
                            menuList={memberfieldData.current_life_cover.extra.optionList}
                            value={memberfieldData.current_life_cover.value}
                            onSelect={(value) => updateValues(formController, member[0], 'current_life_cover', value)}
                            showErrorMsg={memberfieldData.current_life_cover.error !== null}
                            disabled={memberfieldData.current_life_cover.disabled}
                            errorMsg={memberfieldData.current_life_cover.error}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default observer(AddFamilyMemberData)